/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Integrations_Wizard_Connect_HintInputs */



/**
* | output |
* | --- |
* | "Authorise the account you want to use. This opens the provider's own sign-in." |
*
* @param {My_Integrations_Wizard_Connect_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const my_integrations_wizard_connect_hint = /** @type {((inputs?: My_Integrations_Wizard_Connect_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Integrations_Wizard_Connect_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Autorisieren Sie das Konto, das Sie nutzen möchten. Dabei öffnet sich die Anmeldung des Anbieters.")
	return /** @type {LocalizedString} */ ("Authorise the account you want to use. This opens the provider's own sign-in.")
});